import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Clock, BookOpen, X, ArrowRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

const ARTICLES = [
  {
    id: 1,
    category: "Cricket",
    categoryColor: "#3B9EFF",
    title: "Kohli vs Records: The Numbers Behind the Legend",
    author: "CricketVault",
    authorAvatar: "https://images.pexels.com/photos/35981350/pexels-photo-35981350.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=100&w=100",
    readTime: "5 min read",
    image: "https://static.prod-images.emergentagent.com/jobs/d3d8e51b-58dc-49f0-8d05-e98008389fca/images/6281644038fee9f9150e467e79f037f8aeb8f640f694b9948b85375a0b9d1bea.png",
    preview:
      "Virat Kohli has redefined batting in the modern era. With over 27,000 international runs and counting, his consistency across all formats is unmatched. In this deep dive, we break down the numbers that tell the story of cricket's greatest run-machine...",
    date: "Dec 15, 2024",
  },
  {
    id: 2,
    category: "Football",
    categoryColor: "#007AFF",
    title: "Premier League 2025: 10 Transfers That Changed Everything",
    author: "GoalKingFC",
    authorAvatar: "https://images.unsplash.com/photo-1757773874306-e80bcf6dc307?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxmb290YmFsbCUyMHNvY2NlciUyMGF2YXRhciUyMGZhbiUyMHBvcnRyYWl0JTIwc3RhZGl1bXxlbnwwfHx8fDE3NzQ1MzcyODd8MA&ixlib=rb-4.1.0&q=85",
    readTime: "7 min read",
    image: "https://images.unsplash.com/photo-1583505996159-307082cf2085?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85&w=600",
    preview:
      "The 2025 summer transfer window was unlike anything we've seen before. Record fees, surprise moves, and the emergence of young talent from unexpected corners of the globe have completely altered the Premier League landscape...",
    date: "Dec 14, 2024",
  },
  {
    id: 3,
    category: "Esports",
    categoryColor: "#a855f7",
    title: "BGMI World Championship: India's Road to Glory",
    author: "BGMIPro99",
    authorAvatar: "https://images.unsplash.com/photo-1673669231301-09baa4d7761b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njd8MHwxfHNlYXJjaHwyfHxnYW1pbmclMjBoZWFkc2V0JTIwZXNwb3J0cyUyMHBsYXllciUyMHNldHVwJTIwZGFya3xlbnwwfHx8fDE3NzQ1MzcyODd8MA&ixlib=rb-4.1.0&q=85",
    readTime: "6 min read",
    image: "https://images.pexels.com/photos/6963945/pexels-photo-6963945.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=600",
    preview:
      "India's BGMI scene has exploded in 2024. From grassroots tournaments to the World Championship stage, the journey of India's top teams has been nothing short of cinematic. Here's how they got there...",
    date: "Dec 12, 2024",
  },
  {
    id: 4,
    category: "Fantasy",
    categoryColor: "#f59e0b",
    title: "Fantasy Sports Tips: Build Your Dream XI This Weekend",
    author: "SportsDesk24",
    authorAvatar: "https://images.unsplash.com/photo-1554941829-1a16e65a02b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxzcG9ydHMlMjBuZXdzJTIwbWljcm9waG9uZSUyMGJyb2FkY2FzdCUyMGpvdXJuYWxpc3R8ZW58MHx8fHwxNzc0NTM3Mjg5fDA&ixlib=rb-4.1.0&q=85",
    readTime: "4 min read",
    image: null,
    preview:
      "This weekend's fixtures offer massive fantasy potential. With 3 key players returning from injury and two high-scoring venues in play, here are our top picks to maximize your points haul...",
    date: "Dec 11, 2024",
  },
  {
    id: 5,
    category: "Cricket",
    categoryColor: "#3B9EFF",
    title: "The IPL Auction Masterclass: Who Got the Best Deals?",
    author: "RohitFanatic",
    authorAvatar: "https://images.unsplash.com/photo-1767783703531-536ea0c32478?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxjcmlja2V0JTIwZmFuJTIwYXZhdGFyJTIwSW5kaWElMjBqZXJzZXklMjBwb3J0cmFpdHxlbnwwfHx8fDE3NzQ1MzcyODR8MA&ixlib=rb-4.1.0&q=85",
    readTime: "8 min read",
    image: null,
    preview:
      "Every year the IPL auction throws up surprises. This year was no different. We analyze every franchise's strategy, highlight the best value buys, and identify which teams are best set up for the 2025 season...",
    date: "Dec 10, 2024",
  },
  {
    id: 6,
    category: "Football",
    categoryColor: "#007AFF",
    title: "La Liga's New Generation: 5 Stars to Watch in 2025",
    author: "FC Diaries",
    authorAvatar: "https://images.unsplash.com/photo-1616514169928-a1e40c6f791c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxmb290YmFsbCUyMGJvb3RzJTIwc29jY2VyJTIwYmFsbCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3NDUzNzYzMXww&ixlib=rb-4.1.0&q=85",
    readTime: "5 min read",
    image: null,
    preview:
      "Spain has always been a factory for football talent, but 2025 might be the year La Liga's new generation truly announces itself to the world. Five names you need to know...",
    date: "Dec 9, 2024",
  },
];

function ArticleCard({ article, onClick, delay }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay }}
      onClick={onClick}
      data-testid={`article-card-${article.id}`}
      className="bg-[#171B24] border border-white/5 hover-glow rounded-2xl overflow-hidden cursor-pointer group hover:-translate-y-2 transition-transform duration-150"
    >
      {article.image && (
        <div className="h-44 overflow-hidden relative">
          <img
            src={article.image}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#171B24] to-transparent" />
        </div>
      )}
      <div className="p-5">
        <span
          className="text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full mb-3 inline-block"
          style={{ background: `${article.categoryColor}20`, color: article.categoryColor, border: `1px solid ${article.categoryColor}40` }}
        >
          {article.category}
        </span>
        <h3 className="font-outfit font-semibold text-white text-base leading-snug mb-3 group-hover:text-[#3B9EFF] transition-colors duration-100">
          {article.title}
        </h3>
        <div className="flex items-center justify-between mt-4 pt-3 border-t border-white/5">
          <div className="flex items-center gap-2">
            <img
              src={article.authorAvatar}
              alt={article.author}
              className="w-6 h-6 rounded-full object-cover flex-shrink-0 ring-1 ring-white/10"
            />
            <span className="text-xs text-[#A1A1AA]">{article.author}</span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-[#A1A1AA]">
            <Clock size={11} />
            {article.readTime}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

export default function ArticlesSection() {
  const [selected, setSelected] = useState(null);

  return (
    <section id="articles" data-testid="articles-section" className="py-24 lg:py-32 bg-[#0B0D12]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mb-16"
        >
          <div className="flex items-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#3B9EFF]" />
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-[#3B9EFF] font-outfit">Articles & Blogs</span>
            <span className="flex items-center gap-1.5 bg-[#3B9EFF]/10 border border-[#3B9EFF]/30 rounded-full px-2.5 py-0.5">
              <span className="w-1.5 h-1.5 rounded-full bg-[#3B9EFF]" />
              <span className="text-[9px] font-black uppercase tracking-wider text-[#3B9EFF]">At Launch</span>
            </span>
          </div>
          <h2 className="font-outfit font-bold text-4xl sm:text-5xl tracking-tight text-white mb-4">
            Stories That Move<br />
            <span className="text-[#3B9EFF]">The Game</span>
          </h2>
          <p className="text-base md:text-lg text-[#A1A1AA] max-w-xl font-inter">
            In-depth analysis, breaking news, creator blogs, and expert opinions — curated for the real fan.
          </p>
        </motion.div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {ARTICLES.map((article, i) => (
            <ArticleCard
              key={article.id}
              article={article}
              delay={i * 0.1}
              onClick={() => setSelected(article)}
            />
          ))}
        </div>

        {/* Read More CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.5 }}
          className="mt-12 text-center"
        >
          <a
            href="#download"
            data-testid="articles-see-more-btn"
            className="inline-flex items-center gap-2 border border-white/20 text-white font-bold rounded-full px-8 py-3.5 hover:border-[#3B9EFF]/50 hover:text-[#3B9EFF] transition-all duration-300 text-sm"
          >
            <BookOpen size={16} />
            See All Articles in App
            <ArrowRight size={16} />
          </a>
        </motion.div>
      </div>

      {/* Article Preview Dialog */}
      <Dialog open={!!selected} onOpenChange={() => setSelected(null)}>
        <DialogContent
          data-testid="article-preview-dialog"
          className="bg-[#171B24] border border-white/10 text-white max-w-lg rounded-2xl"
        >
          <DialogHeader>
            <div className="flex items-center gap-2 mb-3">
              {selected && (
                <span
                  className="text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full"
                  style={{ background: `${selected.categoryColor}20`, color: selected.categoryColor, border: `1px solid ${selected.categoryColor}40` }}
                >
                  {selected?.category}
                </span>
              )}
            </div>
            <DialogTitle className="text-white font-outfit font-bold text-xl leading-snug">
              {selected?.title}
            </DialogTitle>
            <DialogDescription className="sr-only">Article preview for {selected?.title}</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {selected?.image && (
              <img src={selected.image} alt={selected.title} className="w-full h-40 object-cover rounded-xl" />
            )}
            <p className="text-[#A1A1AA] text-sm leading-relaxed">{selected?.preview}</p>
            <div className="flex items-center gap-2 text-xs text-[#A1A1AA] pb-2">
              <Clock size={12} /> {selected?.readTime} &nbsp;·&nbsp; {selected?.date}
            </div>
            <a
              href="#download"
              data-testid="article-read-in-app-btn"
              onClick={() => setSelected(null)}
              className="w-full flex items-center justify-center gap-2 bg-[#3B9EFF] text-black font-bold rounded-full py-3.5 hover:bg-white transition-colors duration-300 text-sm uppercase tracking-wider"
            >
              Read Full Article in App
              <ArrowRight size={16} />
            </a>
          </div>
        </DialogContent>
      </Dialog>
    </section>
  );
}
